import { render } from "./ProfileCard.vue?vue&type=template&id=183cfbef&scoped=true&ts=true"
import script from "./ProfileCard.vue?vue&type=script&lang=ts"
export * from "./ProfileCard.vue?vue&type=script&lang=ts"

import "./ProfileCard.vue?vue&type=style&index=0&id=183cfbef&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-183cfbef"]])

export default __exports__